import React from 'react';
import { Link } from 'react-router-dom';

const Security = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Network Security</h1>

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Security is foundational to every Sarvanta deployment. Our platform integrates
          enterprise-grade security features at every layer, from device authentication to
          encrypted data transport and network access control.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Security Features</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {[
            { title: '802.1X Authentication', desc: 'Port-based network access control for both wired and wireless connections using EAP-TLS, PEAP, and EAP-TTLS protocols.' },
            { title: 'Network Segmentation', desc: 'Isolate guest, corporate, and IoT traffic with dedicated VLANs and per-SSID security policies.' },
            { title: 'Rogue AP Detection', desc: 'Continuous scanning identifies unauthorized access points and potential security threats in your airspace.' },
            { title: 'Encrypted Management', desc: 'All management traffic between access points and the cloud platform is encrypted with TLS 1.3.' },
            { title: 'Captive Portals', desc: 'Customizable captive portals for guest registration, acceptable use policies, and sponsored access.' },
            { title: 'Device Isolation', desc: 'Layer-2 client isolation prevents compromised devices from attacking other clients on the same network.' }
          ].map((item, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: '#60a5fa' }}>{item.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>{item.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            For detailed NAC solutions, see our PacketFence and FreeRADIUS offerings.
          </p>
          <Link to="/nac" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>View NAC Solutions</Link>
        </div>
      </div>
    </div>
  );
};

export default Security;
